// extracted by mini-css-extract-plugin
export var chapterHero = "title-below-hero-module--chapterHero--kgX0N";
export var chapterTextContainer = "title-below-hero-module--chapter-text-container--DsZjn";
export var header = "title-below-hero-module--header--O+bdm";
export var headerYellowText = "title-below-hero-module--headerYellowText--3zl4q";
export var imageContainer = "title-below-hero-module--imageContainer--DKTO2";
export var innerContainer = "title-below-hero-module--innerContainer--1zJIR";
export var listenContainer = "title-below-hero-module--listen-container--vJzYj";